import { all } from "redux-saga/effects"

import documentSaga from "client/documents/saga"
import clientSaga from "client/services/saga"
import socketSaga from "client/socket/saga"
import configurationSaga from "client/config/saga"
import loginSaga from "containers/Login/services/saga"
import adminSaga from "containers/Admin/services/saga"
import surveySaga from "containers/Survey/services/saga"
import insertRelativeSaga from "containers/InsertRelative/services/saga"
import paymentSaga from "containers/Payment/services/saga"
import callSaga from "containers/Call/services/saga"
import profileSaga from "containers/Profile/services/saga"
import SignupSaga from "containers/Signup/services/saga"
import StripeSaga from "containers/Stripe/services/saga"
import StatisticsSaga from "containers/Statistics/services/saga"
import nirReaderSaga from "components/NirReader/services/saga"
import verifyPhoneSaga from "containers/VerifyPhone/services/saga"
import ResetPasswordSaga from "containers/ResetPassword/services/saga"
import DoctorsSaga from "containers/Doctors/services/saga"
import uploadSaga from "containers/Upload/services/saga"
import CarerSaga from "containers/InsertCarer/services/saga"
import VitalsSaga from "containers/Vitals/services/saga"
import ContactlessPaymentSaga from "containers/ContactlessPayment/services/saga"
import DoctorSearchSaga from "containers/DoctorSearch/services/saga"
import teleexpertiseSaga from "containers/Teleexpertise/services/saga"

export default function* IndexSaga(): Generator {
  yield all([
    clientSaga(),
    adminSaga(),
    loginSaga(),
    paymentSaga(),
    documentSaga(),
    socketSaga(),
    nirReaderSaga(),
    insertRelativeSaga(),
    surveySaga(),
    profileSaga(),
    callSaga(),
    SignupSaga(),
    StripeSaga(),
    verifyPhoneSaga(),
    StatisticsSaga(),
    ResetPasswordSaga(),
    configurationSaga(),
    DoctorsSaga(),
    uploadSaga(),
    CarerSaga(),
    VitalsSaga(),
    ContactlessPaymentSaga(),
    DoctorSearchSaga(),
    teleexpertiseSaga(),
  ])
}
